import { VesselHotoFormElement } from '@app/domain/entities/vessel-hoto-form.entity';

/**
 * The API sends `children: null` on leaf elements; the app walks the tree
 * as arrays everywhere, so every level is normalised to `[]`.
 */
export function mapVesselHotoElements(
  elements: VesselHotoFormElement[] | null | undefined
): VesselHotoFormElement[] {
  return (elements ?? []).map(element => ({
    ...element,
    children: mapVesselHotoElements(element.children),
  }));
}

/** Any response carrying the form's element tree (HOTO form, records, ...). */
export function mapVesselHotoElementTree<
  T extends { elements: VesselHotoFormElement[]; dataSources?: unknown[] },
>(response: T): T {
  return {
    ...response,
    elements: mapVesselHotoElements(response.elements),
    ...(response.dataSources !== undefined && {
      dataSources: response.dataSources ?? [],
    }),
  };
}
